import { useState, useContext } from 'react';
import { RefreshCw } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function ReopenModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleReopen = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.reopenAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit rouvert avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de la réouverture du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error reopening audit plan:', error);
      showError('Erreur lors de la réouverture du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleReopen}
      title="Rouvrir le plan d'audit"
      message="Êtes-vous sûr de vouloir rouvrir ce plan d'audit ? Cela changera le statut de clôturé à complété."
      confirmText={loading ? 'Réouverture...' : 'Rouvrir'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<RefreshCw className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}
